<script setup lang="ts">
import { defineProps, watch } from "vue";
import { useFlyingStars } from "@/utils/useFlyingStars";
import { AptStar } from "@/types/apartmentPlan";
import StarsItem from "@/views/Calculators/ApartmentPlan/components/stage/StarsItem.vue";

const props = defineProps<{
  azimuthFacade: number;
  buildYear: number | null;
  starsPositions: { x: number; y: number; angleDeg: number }[];
  getStarIndex: unknown;
  aptStars: AptStar[] | undefined;
}>();

const { fillBuildYearStars, azimuthFacade, flyingStars, buildMountStars } =
  useFlyingStars();

const baseSequence = ["В", "ЮВ", "Ю", "ЮЗ", "З", "СЗ", "С", "СВ"];
const shiftMap = {
  0: { x: 0, y: 10 },
  4: { x: 0, y: 10 },
  5: { x: -10, y: 10 },
  6: { x: -15, y: 0 },
  7: { x: -10, y: -10 },
};

watch(
  () => props.azimuthFacade,
  () => {
    azimuthFacade.value = props.azimuthFacade;
    buildMountStars();
  },
  { immediate: true }
);

watch(
  () => props.buildYear,
  () => {
    if (props.buildYear) {
      fillBuildYearStars(props.buildYear);
    }
  },
  { immediate: true }
);

function getAptStar(index: number) {
  if (props.aptStars === undefined) {
    return null;
  }

  return index + 3 > 8
    ? props.aptStars[((index + 3) % 9) + 1]
    : props.aptStars[index + 3];
}
</script>

<template>
  <v-group
    v-for="(starPosition, i) in starsPositions"
    :key="i"
    :x="starPosition.x + (shiftMap[i]?.x || 0)"
    :y="starPosition.y + (shiftMap[i]?.y || 0)"
  >
    <!-- Основной контейнер-Group для одной "звезды" -->
    <StarsItem
      :index="i"
      :base-sequence="baseSequence[i]"
      :star-data="flyingStars[getStarIndex(i)]"
      :apt-star="aptStars ? getAptStar(i) : null"
    />
  </v-group>
</template>

<style scoped>
.star-container {
  @apply size-14 border rounded-md grid grid-cols-2 items-center justify-center bg-white border-muted;
}

.current-star {
  @apply rounded-full size-6 flex items-center justify-center;
}

.current-red-star {
  @apply text-white bg-active;
}

.current-white-star {
  @apply border border-black bg-white;
}
</style>
